// 动态改变html的文字大小

function remStyle () {
  // 获取设备的可视宽度
  var w = document.documentElement.clientWidth || document.body.clientWidth
  document.documentElement.style.fontSize = w / 768 * 100 + 'px'
}
remStyle()
window.onresize = remStyle
